Librarian.Modules.Search = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onSearchBoxKeyDown", "onSearchClick", "onClearClick", "onAdvancedClick"],

    options: {
        classPrefix: "modules-search-",
        advancedSearchText: '',
        searchButtonText: '',
        searchPlaceholder: '',
        customSearch: null
    },

    searchBoxEl: null,
    searchButtonEl: null,
    clearButtonEl: null,
    advancedSearchEl: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        var self = this;
        if (!this.wrapperEl)
            return;

        this.parent();

        this.searchBoxWrapperEl = new Element("div",
        {
            "id": this.options.id + "_searchBox-wrapper"
        }).injectInside(this.containerEl);;

        this.searchBoxEl = new Element("input[type=text]", {
            "placeholder": this.options.searchPlaceholder || Librarian.Lang.getString("modules_search_placeholder"),
            "id": this.options.id + "_searchBox",
            "class": (this.options.classPrefix || '') + "box"
        }).injectInside(this.searchBoxWrapperEl);
        this.searchBoxEl.addEvent("keydown", this.onSearchBoxKeyDown);

        Librarian.ElasticSearch.Autocomplete.createAutoCompleteElement(this.searchBoxEl);

        this.searchIcon = new Element("div",
            {
                "class": "search-icon"
            }).injectInside(this.searchBoxWrapperEl);
        this.searchIcon.addOnClick(function() {
            Library.searchToolbarSubmit(self.searchBoxEl.id, self.options.customSearch);
        });

        var buttonContEl = new Element("div", {
            "class" : (this.options.classPrefix || '') + "button-wrapper"
        }).injectInside(this.containerEl);

        this.searchButtonEl = new Element("input[type=button]", {
            "value": this.options.searchButtonText || Librarian.Lang.getString("search"),
            "class": (this.options.classPrefix || '') + "button pure-button"
        }).injectInside(buttonContEl);
        this.searchButtonEl.addOnClick(this.onSearchClick);

        this.clearButtonEl = new Element("input[type=button]", {
            "value": Librarian.Lang.getString("clear"),
            "class": (this.options.classPrefix || '') + "clear pure-button"
        }).injectInside(buttonContEl);
        this.clearButtonEl.addOnClick(this.onClearClick);

        this.advancedSearchEl = new Element("a", {
            "text": this.options.advancedSearchText || (Librarian.Lang.getString("search_advanced") + " >"),
            "href": "javascript:void(0)",
            "class": (this.options.classPrefix || '') + "advanced"
        }).injectInside(this.containerEl);
        this.advancedSearchEl.addOnClick(this.onAdvancedClick);
    },

    destroy: function() {
        var elements = [this.searchBoxEl, this.searchButtonEl, this.clearButtonEl, this.advancedSearchEl];
        for (var i = elements.length; i--;) {
            if (elements[i]) {
                $(elements[i]).destroy();
                elements[i] = null;
            }
        }

        this.parent();
    },

    onSearchBoxKeyDown: function(e) {
        if (!this.searchBoxEl)
            return;

        var evt = new Event(e);
        if (evt.keyCode == 13)
            Library.searchToolbarSubmit(this.searchBoxEl.id, this.options.customSearch);
    },

    onSearchClick: function() {
        if (!this.searchBoxEl)
            return;

        // If "modified" hasn't been set, no value has been entered in the box and we don't want to search on the default
        if (typeof this.searchBoxEl.modified != "boolean")
            return;

        Library.searchToolbarSubmit(this.searchBoxEl.id, this.options.customSearch);
    },

    onClearClick: function() {
        if (!this.searchBoxEl)
            return;

        this.searchBoxEl.value = this.options.searchPlaceholder || Librarian.Lang.getString("modules_search_placeholder");
        this.searchBoxEl.modified = true;
    },

    onAdvancedClick: function() {
        Library.loadTabByName("search");
        return false;
    }
});